export default __webpack_public_path__ + "static/media/ARM_frame_arm_2.d42624c2.png";